import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import { RouteComponentProps } from 'react-router-dom';
import styles from './styles';
import GMap from '../../components/GMap';
import ActivationLogs from '../../components/ActivationLogs';
import ActivationLockList from '../../components/ActivationLockList';
import ActivationFilter from '../../components/ActivationFilter';
import { useGetHubActivationMap } from '../../hooks/useGetHubActivationMap';
import { Order } from '../../utils/table';
import { PropertiesActiveLocks } from '../../redux/types/properties';

type Props = {
  loadActivePropertiesLocks: () => void;
  activePropertiesLocks: PropertiesActiveLocks[];
} & WithStyles<typeof styles> & RouteComponentProps;

export const ActivationMap = (props: Props) => {
  const {
    classes,
    match,
    history,
    activePropertiesLocks,
    loadActivePropertiesLocks,
  } = props;

  const [filters, setFilters] = useState({
    activatedBy: [] as string[],
    communityIds: [] as string[],
    propertyIds: [] as string[],
  });

  const [sort, setSort] = useState<{
    orderBy: string;
    order: Order;
  }>({
    orderBy: 'hub_activity_log.created_on',
    order: 'desc',
  });

  const [filterOptions, setFilterOptions] = useState<{
    communities: { id: number; name: string }[];
    properties: { id: number; address: string }[];
    activatedBy: string[];
  }>({
    communities: [],
    properties: [],
    activatedBy: [],
  });

  const { data: hubActivationMap } = useGetHubActivationMap({
    order: sort.order,
    orderBy: sort.orderBy,
    filters,
  });

  const data = hubActivationMap?.data ?? [];

  useEffect(() => {
    if (data.length && !filterOptions.communities.length) {
      setFilterOptions({
        communities: [...new Map(
          data
            .filter((item) => item.communityId && item.communityName)
            .map((item) => [item.communityId, { id: item.communityId, name: item.communityName }]),
        ).values()],
        properties: [...new Map(
          data
            .filter((item) => item.property_id && item.propertyAddress)
            .map(
              (item) => [item.property_id, { id: item.property_id, address: item.propertyAddress }],
            ),
        ).values()],
        activatedBy: [...new Set(data.map((item) => item.created_by).filter(Boolean))],
      });
    }
  }, [data, filterOptions.communities]);

  const handleHubSelect = (serialNumber: string) => {
    history.push(`${match.url}/${serialNumber}`);
  };

  useEffect(() => {
    loadActivePropertiesLocks();
  }, [loadActivePropertiesLocks]);

  return (
    <Box className={classes.container}>
      <ActivationFilter
        communities={filterOptions.communities}
        properties={filterOptions.properties}
        activatedBy={filterOptions.activatedBy}
        filters={filters}
        onFiltersChange={setFilters}
      />
      <Grid container spacing={2} className={classes.contentContainer}>
        <Grid item xs={6}>
          <GMap
            logs={data}
            handleHubSelect={handleHubSelect}
          />
        </Grid>
        <Grid item xs={6} className={classes.rightColumn}>
          <Box className={classes.rightColumnItem}>
            <ActivationLogs
              logs={data}
              orderBy={sort.orderBy}
              order={sort.order}
              onSort={(orderBy, order) => setSort({ orderBy, order })}
            />
          </Box>
          <Box className={classes.rightColumnItem}>
            <ActivationLockList listLocks={activePropertiesLocks}/>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
